import { useLocation } from "react-router-dom";

export function useTrainerRoleRoute() {
  const { pathname } = useLocation();
  const basePath = pathname.toLowerCase().startsWith("/regional-coordinator")
    ? "/regional-coordinator"
    : "/trainerLayout";

  return (path) => `${basePath}/${path.replace(/^\/+/, "")}`;
}
